// extracted by mini-css-extract-plugin
export default {"minWrapper":"VehiclePriceDiscount_minWrapper__A77CX"};